import { render, staticRenderFns } from "./CoursewareBlockEdit.vue?vue&type=template&id=8ce0de48&"
import script from "./CoursewareBlockEdit.vue?vue&type=script&lang=js&"
export * from "./CoursewareBlockEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports